import { forwardRef } from 'react';
import { Box, Stack, SxProps } from '@mui/material';

import { NavbarView } from './NavbarView';
import { NavbarViewV1 } from './NavbarViewV1';
import { NavbarViewProps } from './type';

import { FEATURE_FLAGS } from '~common';
import { checkEnabledFeatureFlag } from '~utils';

type NavbarProps = NavbarViewProps & {
  sxProps?: SxProps;
};

export const Navbar = forwardRef<HTMLDivElement, NavbarProps>(
  ({ sxProps = {}, ...navBarViewProps }, ref) => {
    const configurableWebAppBannerFeature = checkEnabledFeatureFlag(
      FEATURE_FLAGS.CONFIGURABLE_WEB_APP_BANNER,
    );

    return (
      <Box
        ref={ref}
        sx={{
          top: 0,
          width: '100%',
          height: 'auto',
          position: 'sticky',

          display: 'flex',
          flexDirection: 'column',

          zIndex: 100,
        }}
      >
        <Stack
          sx={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',

            pt: 1.75,
            pb: 1.5,
            px: 2.5,

            bgcolor: 'brand.lightest',
            borderBottom: '1px solid #CCEDFF',

            ...sxProps,
          }}
        >
          {configurableWebAppBannerFeature ? (
            <NavbarViewV1 {...navBarViewProps} />
          ) : (
            <NavbarView />
          )}
        </Stack>
      </Box>
    );
  },
);

// Set display name for better debugging
Navbar.displayName = 'Navbar';
